import React from 'react';
import loadable from '@loadable/component';

import loadingAnimation from 'app/assets/animations/loading.json';
const LottieLazy = loadable.lib(() => import('lottie-react'));
const Loader = () => {
  return (
    <div
      data-testid="loader-component"
      className="flex items-center justify-center h-[80vh]"
    >
      <LottieLazy>
        {({ default: Lottie }) => (
          <Lottie animationData={loadingAnimation} loop={true} />
        )}
      </LottieLazy>
    </div>
  );
};

export default Loader;
